import { useEffect } from 'react';

const IGNORED_TAGS = new Set(['TEXTAREA', 'BUTTON', 'SELECT', 'A']);

export const useEnterToAdvance = (handler: (() => void | Promise<void>) | null) => {
  useEffect(() => {
    if (!handler) return;
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key !== 'Enter') return;
      if (e.shiftKey || e.metaKey || e.ctrlKey || e.altKey) return;
      if (e.isComposing) return;
      const target = e.target as HTMLElement | null;
      if (target) {
        if (IGNORED_TAGS.has(target.tagName)) return;
        if (target.isContentEditable) return;
        const role = target.getAttribute('role');
        if (role === 'button' || role === 'menuitem' || role === 'menuitemradio') return;
        // Sheets and dialogs portal to <body>, so their keystrokes still reach this listener.
        if (target.closest('[role="dialog"], [role="alertdialog"]')) return;
      }
      e.preventDefault();
      void handler();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [handler]);
};
